var map = {
	"./": 18305,
	"./App": 44843,
	"./App.css": 93508,
	"./App.js": 44843,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./ENV": 15528,
	"./ENV.json": 15528,
	"./GPS_SAVED.png": 4824,
	"./GPS_TEMP.png": 32090,
	"./GPS_TO_ADD.png": 63647,
	"./Views/ExternalpartnerMap": 4948,
	"./Views/ExternalpartnerMap.js": 4948,
	"./Views/ItineraryLab": 76725,
	"./Views/ItineraryLab.css": 97496,
	"./Views/ItineraryLab.js": 76725,
	"./Views/Lab": 49836,
	"./Views/Lab.js": 49836,
	"./Views/LoginForm.css": 93994,
	"./Views/LoginPage": 71273,
	"./Views/LoginPage.css": 94940,
	"./Views/LoginPage.js": 71273,
	"./component/AgreeAndContinue": 50631,
	"./component/AgreeAndContinue.js": 50631,
	"./component/AlertForCreator": 41813,
	"./component/AlertForCreator.css": 6732,
	"./component/AlertForCreator.js": 41813,
	"./component/BarAction": 46358,
	"./component/BarAction.css": 81105,
	"./component/BarAction.js": 46358,
	"./component/CensimentoDim": 75431,
	"./component/CensimentoDim.js": 75431,
	"./component/DialogChoose": 95726,
	"./component/DialogChoose.js": 95726,
	"./component/DimensioneMap": 76026,
	"./component/DimensioneMap.js": 76026,
	"./component/DocsElement": 63333,
	"./component/DocsElement.css": 86879,
	"./component/DocsElement.js": 63333,
	"./component/EditorPointOfInterest": 52927,
	"./component/EditorPointOfInterest.js": 52927,
	"./component/FileUploader": 32935,
	"./component/FileUploader.css": 60157,
	"./component/FileUploader.js": 32935,
	"./component/LeaveEmpty": 55147,
	"./component/LeaveEmpty.css": 39212,
	"./component/LeaveEmpty.js": 55147,
	"./component/Loading": 37895,
	"./component/Loading.js": 37895,
	"./component/LoginForm": 70846,
	"./component/LoginForm.js": 70846,
	"./component/MapLayerControl": 17057,
	"./component/MapLayerControl.js": 17057,
	"./component/MapLegend": 73062,
	"./component/MapLegend.css": 51421,
	"./component/MapLegend.js": 73062,
	"./component/POI_INFO": 43734,
	"./component/POI_INFO.json": 43734,
	"./component/PageLayout": 23753,
	"./component/PageLayout.js": 23753,
	"./component/PartnerMapPage": 63538,
	"./component/PartnerMapPage.js": 63538,
	"./component/PointOfInterest.css": 21698,
	"./component/PointOfInterestForm": 38020,
	"./component/PointOfInterestForm.js": 38020,
	"./component/Popup": 99554,
	"./component/Popup.css": 46938,
	"./component/Popup.js": 99554,
	"./component/RefreshBtn": 27439,
	"./component/RefreshBtn.js": 27439,
	"./component/RequestingPopup": 6499,
	"./component/RequestingPopup.js": 6499,
	"./component/ScrollToTop.css": 87645,
	"./component/ScrooToTop": 85647,
	"./component/ScrooToTop.js": 85647,
	"./component/SearcherPOI": 24285,
	"./component/SearcherPOI.js": 24285,
	"./component/SearcherPoi.css": 11846,
	"./component/TrashPointOfInterest": 17472,
	"./component/TrashPointOfInterest.css": 31896,
	"./component/TrashPointOfInterest.js": 17472,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./logo_o.png": 69873,
	"./no_internet.svg": 62059,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./success.svg": 72823,
	"./utils": 34457,
	"./utils.js": 34457,
	"./utils/docs": 93550,
	"./utils/docs.json": 93550,
	"./utils/legal_docs": 5152,
	"./utils/legal_docs.json": 5152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;